import axiosPrivate from "@services/axiosPrivate"
import { CANCEL_CALENDAR_EVENT } from "src/constants"

export const cancelGoogleEvent = (data) =>
    axiosPrivate.post(CANCEL_CALENDAR_EVENT, data, { withCredentials: true })
